import { React, useEffect } from "react";
import Aos from "aos";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";


export function Gallery() {
    useEffect(() => {
        document.title = "Academia Balam Boox";
        Aos.init();
    }, []);

    return (
        <>
            <Header />
            <section className="d-flex flex-column min-vh-100 bgDeg justify-content-center pt-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-6" data-aos="fade-up">
                            <div className="card welcome-card">
                                <div className="card-body text-center">
                                    <h3 className="card-title">PÁGINA EN PROGRESO</h3>
                                    <p className="card-text mb-4">Se trabaja en la sección de galería.</p>
                                    <p className="card-text">Pausa para café <i className="bi bi-cup-hot-fill"></i></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}